import { TranslationKey } from './types';

export default {
	DEFERRED_PAYMENT_BANNER_1:
		'Plaťte pohodlně až\u00A0po\u00A0doručení a\u00A0vyzkoušení zboží. Zdarma a\u00A0bez navýšení.',
	DEFERRED_PAYMENT_BANNER_2: 'Dnes za\u00A00\u00A0Kč, zbytek za\u00A030\u00A0dní.',
	PAY_IN_THREE_BANNER_1:
		'Rozdělte si platbu na\u00A0třetiny. První zaplatíte hned, zbylé dvě za\u00A030\u00A0a\u00A060\u00A0dní. Zdarma a\u00A0bez navýšení.',
	PAY_IN_THREE_BANNER_WITH_AMOUNT:
		'Zaplaťte ve 3\u00A0platbách ve výši {amount}. Zdarma a\u00A0bez navýšení.',
	MORE_INFO: 'Jak\u00A0na\u00A0to?',
	DEFERRED_PAYMENT_MODAL_TITLE: 'Nakupte teď, zaplaťte za 30\u00A0dní',
	DEFERRED_PAYMENT_MODAL_SUB_TITLE: 'Zdarma a\u00A0bez navýšení',
	DEFERRED_PAYMENT_MODAL_STEP_1: 'Přidejte\u00A0zboží do\u00A0košíku.',
	DEFERRED_PAYMENT_MODAL_STEP_2:
		'Z\u00A0nabídky platebních metod vyberte Odloženou platbu Skip\u00A0Pay.',
	DEFERRED_PAYMENT_MODAL_STEP_3:
		'Hotovo, Skip\u00A0Pay nákup uhradí za\u00A0vás. Vy máte na\u00A0vyzkoušení a\u00A0zaplacení celých 30\u00A0dní.',
	MODAL_MORE_INFO: 'Více\u00A0informací',
	PAY_IN_THREE_MODAL_TITLE: 'Rozdělte si platbu nákupu na\u00A0třetiny',
	PAY_IN_THREE_MODAL_SUB_TITLE: 'Zdarma a\u00A0bez navýšení',
	PAY_IN_THREE_MODAL_STEP_1:
		'Z\u00A0nabídky platebních metod v\u00A0košíku vyberte nákup na\u00A0Třetinu se\u00A0Skip\u00A0Pay.',
	PAY_IN_THREE_MODAL_STEP_1_DYNAMIC:
		'V\u00A0košíku vyberte jako způsob platby Nákup na\u00A0Třetinu od\u00A0Skip\u00A0Pay.',
	PAY_IN_THREE_MODAL_STEP_2: 'První třetinu ceny nákupu uhraďte platební\u00A0kartou.',
	PAY_IN_THREE_MODAL_STEP_3: 'Hotovo. Zbylé dvě třetiny doplatíte za\u00A030 a\u00A060\u00A0dní.',
	PAY_IN_THREE_MODAL_PAY_TODAY: 'Platíte dnes',
	PAY_IN_THREE_UNTIL: 'do',
	CLOSE_MODAL: 'Zavřít',
} as Record<TranslationKey, string>;
